import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './overlay-button.scss';

function OverlayButton({ onClick, text, icon: Icon, className }) {
  return (
    <button
      onClick={onClick}
      className={classNames(styles.button, className, {
        [styles.withText]: Boolean(text),
      })}
    >
      <Icon className={styles.icon} />
      {text && <span className={styles.text}>{text}</span>}
    </button>
  );
}

OverlayButton.propTypes = {
  icon: PropTypes.func.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default OverlayButton;
